<template>
  <div>
    <div v-if="item.status === 'WRITTEN_OFF'">
      <!-- nothing -->
    </div>
    <div v-if="item.status === 'READY_FOR_USE'">
      <v-menu
        slot="activator"
        bottom
        left
        origin="right top"
        transition="scale-transition"
      >
        <v-btn
          slot="activator"
          icon
        >
          <v-icon>more_vert</v-icon>
        </v-btn>

        <v-list>
          <v-list-tile @click="$emit('clicked', 'equip', item)">
            <v-list-tile-title>{{ $t('label__equip') }}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="$emit('clicked', 'writeoff', item)">
            <v-list-tile-title>{{ $t('label__writeoff') }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>
    <div v-if="item.status === 'ON_WAREHOUSE'">
      <v-menu
        slot="activator"
        bottom
        left
        origin="right top"
        transition="scale-transition"
      >
        <v-btn
          slot="activator"
          icon
        >
          <v-icon>more_vert</v-icon>
        </v-btn>

        <v-list>
          <v-list-tile @click="$emit('clicked', 'makeReady', item)">
            <v-list-tile-title>{{ $t('label__make_ready') }}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="$emit('clicked', 'writeoff', item)">
            <v-list-tile-title>{{ $t('label__writeoff') }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>
    <div v-if="item.status === 'READY_FOR_SHIPMENT'">
      <v-menu
        slot="activator"
        bottom
        left
        origin="right top"
        transition="scale-transition"
      >
        <v-btn
          slot="activator"
          icon
        >
          <v-icon>more_vert</v-icon>
        </v-btn>

        <v-list>
          <v-list-tile @click="$emit('clicked', 'edit', item)">
            <v-list-tile-title>{{ $t('label__edit') }}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="$emit('clicked', 'move', item)">
            <v-list-tile-title>{{ $t('label__move') }}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="$emit('clicked', 'ship', item)">
            <v-list-tile-title>{{ $t('label__ship') }}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="$emit('clicked', 'writeoff', item)">
            <v-list-tile-title>{{ $t('label__writeoff') }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DeviceTableActions',
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
}
</script>
